// /k/:token — the personal short-URL entry point. Calls by-token, shows a
// "歡迎，[name]！" greeting for ~1.5s with Framer Motion fade, then navigates
// home. If the token is unknown (lost sticker, wrong scan), points the kid at
// the class-code fallback.

import { useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useLoginByToken } from '../auth/hooks.ts'
import { WelcomeSkeleton } from '../components/Skeleton.tsx'

const WELCOME_MS = 1500

export function KEntryPage() {
  const { token = '' } = useParams<{ token: string }>()
  const navigate = useNavigate()
  const { mutate, data: user, error, isPending } = useLoginByToken()

  useEffect(() => {
    if (token) mutate(token)
  }, [token, mutate])

  useEffect(() => {
    if (!user) return
    const t = setTimeout(() => navigate('/', { replace: true }), WELCOME_MS)
    return () => clearTimeout(t)
  }, [user, navigate])

  if (error) {
    return (
      <main className="mx-auto flex min-h-full max-w-md flex-col items-center justify-center gap-4 p-8 text-center">
        <p className="text-lg text-[var(--color-fg)]">找不到這個連結 🙃</p>
        <p className="text-sm text-[var(--color-muted)]">可能是貼紙刮花了。可以用班級代碼登入：</p>
        <Link
          to="/login"
          className="rounded-[var(--radius-pill)] bg-[var(--color-joseph-primary)] px-6 py-2 text-white"
        >
          用班級代碼登入
        </Link>
      </main>
    )
  }

  if (isPending || !user) return <WelcomeSkeleton />

  return (
    <main className="mx-auto flex min-h-full max-w-md flex-col items-center justify-center gap-6 p-8 text-center">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="flex flex-col items-center gap-3"
        aria-live="polite"
      >
        <p className="font-[family-name:var(--font-display)] text-3xl text-[var(--color-fg)]">
          歡迎，{user.displayName}！
        </p>
        <p className="text-sm text-[var(--color-muted)]">準備開始今天的故事 ✨</p>
      </motion.div>
    </main>
  )
}
